import React from 'react';
import { Box, Typography } from '@mui/material';
import { theme } from '../../../constants/theme';
import { useThemeContext } from '../../../hook/useThemeManager';
import { FONT_ENUM } from '../../../types/global/fonts.types';
import { useLottie } from 'lottie-react';
import { emptyState } from '../../../assets/animations';

interface IEmptySearchBlock {
    title?: string;
    subTitle?: string;
    animation?: any;
    animationStyle?: React.CSSProperties;
    mainHeaderStyle?: React.CSSProperties;
    subHeaderStyle?: React.CSSProperties;
    actionButton?: JSX.Element;
}
const EmptySearchBlock: React.FC<IEmptySearchBlock> = ({
    title,
    subTitle,
    animation,
    animationStyle,
    mainHeaderStyle,
    subHeaderStyle,
    actionButton,
}) => {
    const { themeStyle } = useThemeContext();
    const options = {
        animationData: animation,
        loop: true,
    };

    const style = {
        height: 200,
        width: '100%',
        marginTop: 30,
        ...animationStyle,
    };
    const { View } = useLottie(options, style);

    return (
        <Box
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
            }}
            sx={{ gap: '25px' }}>
            <Box>{View}</Box>
            <Box
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                }}
                sx={{ marginTop: -2.5, paddingBottom: 4 }}>
                <Typography
                    style={{
                        fontSize: 24,
                        fontWeight: '600',
                        fontFamily: FONT_ENUM.MAIN_MEDIUM,
                        textAlign: 'center',
                        color: theme[themeStyle].tag_white,
                        ...mainHeaderStyle,
                    }}>
                    {title}
                </Typography>
                <Typography
                    style={{
                        fontSize: 12,
                        fontWeight: '500',
                        fontFamily: FONT_ENUM.MAIN_MEDIUM,
                        textAlign: 'center',
                        color: theme[themeStyle].tag_white,
                        maxWidth: '344px',
                        ...subHeaderStyle,
                    }}>
                    {subTitle}
                </Typography>
            </Box>
            {actionButton && actionButton}
        </Box>
    );
};

EmptySearchBlock.defaultProps = {
    title: 'No Results Found',
    subTitle: '',
    animation: emptyState,
};

export { EmptySearchBlock };
